import { Component, OnInit } from '@angular/core';
import { CallReports } from '../../../model/call-reports';
import { DateArray } from 'ngx-bootstrap/chronos/types';
import * as moment from 'moment';
import { StorageService } from '../../../service/managers/storage.service';

@Component({
  selector: 'voice-reports-table',
  templateUrl: './voice-reports-table.component.html',
  styleUrls: ['./voice-reports-table.component.scss']
})
export class VoiceReportsTableComponent implements OnInit {

  protected maxItemsPerPage: number;
  protected page: number;
  protected total: number;

  protected keyword: string;

  private report_list:CallReports[]

  private date_range:string;
  private url:string;
  private new_url:string;

  constructor(
    private sto:StorageService
  ) { }

  ngOnInit() {
      this.report_list = [{
        'id' : 1,
        'report_name' : 'Call Histories'
     }];

     this.url = 'https://voice.worldvision.org.ph/voiceapp/backend/public/api/call_history?';
  }

  downloadExcel(){
    let dt = this.date_range.toString().split(',');
    const date_from = dt[0];
    const date_to = dt[1];
    let dfrom = moment(date_from).format( "YYYY-MM-DD").toString()
    let dto = moment(date_to).format( "YYYY-MM-DD").toString()
   
    this.new_url = this.url + 'date_from=' + dfrom + '&date_to=' + dto + '&token=' + this.sto.getAccessToken()
    
  }



}
